import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { NbAuthComponent } from '@nebular/auth';
import { AuthLoginComponent } from '@pages/auth/login/login.component';
import { AuthLogoutComponent } from '@pages/auth/logout/logout.component';
import { NewAuthLoginComponent } from '@pages/auth/login/newlogin.component';

const routes: Routes = [
    { path: 'pages', loadChildren: 'app/pages/pages.module#PagesModule' },
    {
        path: 'auth',
        component: NbAuthComponent,
        children: [
            {
                path: '',
                component: AuthLoginComponent,
            },
            {
                path: 'login',
                component: AuthLoginComponent,
            },
            {
                path: 'newlogin',
                component: NewAuthLoginComponent,
            },
            // {
            //     path: 'register',
            //     component: NbRegisterComponent,
            // },
            {
                path: 'logout',
                component: AuthLogoutComponent,
            },
            // {
            //     path: 'request-password',
            //     component: NbRequestPasswordComponent,
            // },
            // {
            //     path: 'reset-password',
            //     component: NbResetPasswordComponent,
            // },
        ],
    },
    { path: '', redirectTo: 'pages', pathMatch: 'full' },
    { path: '**', redirectTo: 'pages' },
];

const config: ExtraOptions = {
    useHash: true,
};

@NgModule({
    imports: [RouterModule.forRoot(routes, config)],
    exports: [RouterModule],
})
export class AppRoutingModule {
}